module.exports = __webpack_public_path__ + "images/f4437040dfd36640a193069b9fd4e3a3.svg";